module.exports = __webpack_public_path__ + "static/media/girlWithPurpleFolderAndGreenPaper.8e14ee30.svg";